<template>
  <div>
    <div class="form-container ou-donation-form teach-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <div>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>
            <p
              class="note"
              style="
                font-weight: 400;
                font-size: 16px;
                margin: 16px 0px 0px;
                font-style: italic;
              "
            >
              * All donations $1,800 or more are included as Leadership Circle Members.
            </p>
            <p
              class="note"
              style="
                font-weight: 400;
                font-size: 16px;
                margin: 9px 0px 0px;
                font-style: italic;
              "
            >
              * All donations $5,000 or more included as Benefactors Circle Members.
            </p>
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Recurring Monthly Gift" />
            </div>
            <!-- <DonationFrequency />  -->
            <TransactionFee />
          </FormSection>
          <FormSection title="Your Contact Information">
            <FormRow inline>
              <FormCol simpleTitle="true" field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>               
            <FormRow>
              <FormLabel>
                <NewsletterSubscribe
                  text="Click here if you would like to receive email updates"
                />
              </FormLabel>
            </FormRow>
            <br />
            <InHonorOf />
            <br />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="">
            <FormRow>
              <FormLabel class="control-label"> Notes </FormLabel>
            </FormRow>
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection title="Payment Info" last>
            <div class="payment-info">
              <FormRow>
                <PaymentType cc_text="Credit Card" check_text="Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Teach Coalition<br />
                      C/O Caleb Fischer<br />
                      40 Rector St, 4th Floor<br />
                      New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" class="teachpay" />
        </PaymentForm>
        <div class="footer-links">
          Contact
          <a href="mailto:donate@teachcoalition.org">donate@teachcoalition.org</a> or
          <a href="tel:201.565.3734">201.565.3734</a> for more information. <br />
          Or see
          <a href="https://teachcoalition.org/donate/#predonates"
            >More ways to Donate here.</a
          >
        </div>
        <div class="footer-copyright">
          Teach Coalition, a project of the Orthodox Union, is a 501(c)(3), EIN:
          13-5623717.<br />
          All donations to Teach Coalition are tax-deductible to the full extent permitted
          by law.
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  components: {},
  setup(props) {
    const { form, setValue } = usePaymentForm();

    return {
      form,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro {
  font-size: 18px;
  line-height: 26px;
  color: #00346b;
  p {
    margin-bottom: 10px;
  }
  a {
    color: #00346b;
    font-weight: 600;
  }
}

.form-container.ou-donation-form.teach-donation-form {
  max-width: 770px;
  overflow: hidden;
  box-shadow: none;
  padding: 10px 10px 62px;
  @media only screen and (min-width: 720px) {
    padding: 0px 50px 0px;
    margin: 0px auto;
  }
}
.teach-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: space-between;

  label {
    border: 1px solid #0d346c;
    color: #000000;
    font-size: 15px;
    line-height: 1;
    &:hover {
      background: #f7f7f7;
    }
  }
  input[type="radio"]:checked + label {
    background: #0d346c;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0d346c;
    border-color: #0d346c;
  }
  .label-description {
    font-size: 16px;
  }
  .label-amount {
    background: #0d346c;
    color: white;
  }
  .radio-part {
    min-width: 33%;
    line-height: 20px;
    max-width: 33%;
  }
}

.footer-links {
  text-align: center;
  font-size: 16px;
  margin: 50px auto 28px;
  line-height: 26px;
  color: #00346b;
  a {
    text-decoration: none;
  }
}
.footer-copyright {
  line-height: 15px;
  text-align: center;
  font-size: 12px;
  color: #222;
  font-style: italic;
}

.payment {
  margin: 20px auto 20px;
  ::v-deep .ou-donation-btn {
    width: 300px;
    max-width: 100%;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
  }
}

.frequency {
  margin-top: 20px;
}
// .teach-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation{
// 		.radio-part{
// 	  @media only screen and (min-width: 720px) {
// 			min-width: 50%;
// 			max-width: 50%;
// 		}
// 		}
// }

label {
  line-height: normal;
}
.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}


.teach-donation-form ::v-deep .styled-radio--ou-donation.styled-radio label {
  font-size: 16px;
  line-height: 1 !important;
}
.teach-donation-form
  ::v-deep
  .styled-radio--ou-donation
  .amount_other__wrapper
  input[type="number"] {
  font-size: 16px;
}

.teach-donation-form
  ::v-deep
  .payment-info
  .styled-radio-container--ou-donation.styled-radio-container
  .radio-part {
  min-width: 50%;
  max-width: 50%;
}
.teach-donation-form ::v-deep .amount_other__wrapper.USD {
  margin-top: 8px !important;
  @media only screen and (max-width: 720px) {
    min-width: 90% !important;
    max-width: 90% !important;
  }
}

.teach-donation-form ::v-deep {
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(1),
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(2),
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(3),
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(4) {
    label {
      background: #00346b;
      color: #fff;
    }
    input[type="radio"]:checked + label {
      background: #15329d;
      color: white;
    }
    .money_format.label-amount {
      position: relative;
    }
  }
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(1),
  .styled-radio--ou-donation.styled-radio .radio-part:nth-child(2) {
    .money_format.label-amount {
      padding-right: 9px;
    }
    .money_format.label-amount:after {
      content: "*";
      position: absolute;
      right: 0px;
      font-size: 13px;
      margin-left: 0px;
    }
  }
}
</style>
